module.exports = __webpack_public_path__ + "img/11.35a0de37.png";